module.exports = __webpack_public_path__ + "img/select-photo.f9106db6.svg";